export default [
  
  [{ size: [ 'small', false, 'large', 'huge' ]}],
  ["bold", "italic", "underline"] ,
  [{ 'color': [] }, { 'background': [] }], 
  [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }]
];
